import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Languages, Loader2 } from "lucide-react";
import { langFlag, langLabel } from "@/lib/langLabel";

// Admin-only: shows the French translation of an incoming client message below the original,
// with a "detected language" badge. Uses the cached DB value (text_fr / src_lang / is_fr) when
// available; otherwise translates once and the backend persists it (zero extra IA calls after).
export const AutoTranslateFR = ({ text, msgId, source, cachedFr = "", cachedIsFr = false, cachedLang = "" }) => {
  const hasCache = cachedIsFr || !!cachedFr;
  const [state, setState] = useState({
    loading: !hasCache,
    fr: cachedFr || "",
    same: !!cachedIsFr,
    lang: cachedLang || "",
  });

  useEffect(() => {
    if (hasCache || !msgId || !source) return;
    let alive = true;
    const t = (text || "").trim();
    if (!t) { setState({ loading: false, fr: "", same: true, lang: "" }); return; }
    api.post(`/admin/messages/${source}/${msgId}/translate-fr`)
      .then(({ data }) => { if (alive) setState({ loading: false, fr: data.translated || "", same: !!data.same, lang: data.lang || "" }); })
      .catch(() => { if (alive) setState({ loading: false, fr: "", same: true, lang: "" }); });
    return () => { alive = false; };
  }, [msgId, source, text, hasCache]);

  if (state.same || (!state.loading && !state.fr)) return null;

  const showLang = state.lang && state.lang.toLowerCase() !== "fr";

  return (
    <div className="mt-1.5 pt-1.5 border-t border-white/10" data-testid="auto-translate-fr">
      <div className="flex items-center gap-1.5 mb-0.5">
        <Languages className="w-2.5 h-2.5 text-aurora-cyan" />
        <span className="font-mono text-[8px] uppercase tracking-widest text-aurora-cyan">FR</span>
        {showLang && (
          <span data-testid="detected-lang-badge"
            className="flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-white/5 border border-white/10 font-mono text-[8px] uppercase tracking-widest text-zinc-400">
            <span className="text-[10px] leading-none">{langFlag(state.lang)}</span> {langLabel(state.lang)}
          </span>
        )}
      </div>
      {state.loading
        ? <span className="flex items-center gap-1 text-[11px] text-zinc-500"><Loader2 className="w-2.5 h-2.5 animate-spin" /> Traduction…</span>
        : <p className="text-xs text-zinc-300 italic whitespace-pre-wrap break-words">{state.fr}</p>}
    </div>
  );
};
